import {
  COMPLETED_SLP_LIST_FAILURE,
  COMPLETED_SLP_LIST_PDF_FAILURE,
  COMPLETED_SLP_LIST_PDF_REQUEST,
  COMPLETED_SLP_LIST_PDF_SUCCESS,
  COMPLETED_SLP_LIST_REQUEST,
  COMPLETED_SLP_LIST_SUCCESS,
  PLA_USER_LIST_FAILURE,
  PLA_USER_LIST_REQUEST,
  PLA_USER_LIST_SUCCESS,
  SLP_REQUESTS_FAILURE,
  SLP_REQUESTS_PDF_FAILURE,
  SLP_REQUESTS_PDF_REQUEST,
  SLP_REQUESTS_PDF_SUCCESS,
  SLP_REQUESTS_REQUEST,
  SLP_REQUESTS_SUCCESS,
  UPDATE_SLP_CONTACT_NOTE_FAILURE,
  UPDATE_SLP_CONTACT_NOTE_REQUEST,
  UPDATE_SLP_CONTACT_NOTE_SUCCESS,
  UPDATE_SLP_CONTACT_PROGRESS_FAILURE,
  UPDATE_SLP_CONTACT_PROGRESS_REQUEST,
  UPDATE_SLP_CONTACT_PROGRESS_SUCCESS,
  UPDATE_SLP_PARTICIPATION_FAILURE,
  UPDATE_SLP_PARTICIPATION_REQUEST,
  UPDATE_SLP_PARTICIPATION_SUCCESS,
  VIEW_SLP_GOALS_ASSESSMENT_PDF_FAILURE,
  VIEW_SLP_GOALS_ASSESSMENT_PDF_REQUEST,
  VIEW_SLP_GOALS_ASSESSMENT_PDF_SUCCESS,
} from "./actionTypes";
import {
  CompletedSLPListFailure,
  CompletedSLPListFailurePayload,
  CompletedSLPListPayload,
  CompletedSLPListPDFFailure,
  CompletedSLPListPDFFailurePayload,
  CompletedSLPListPDFPayload,
  CompletedSLPListPDFRequest,
  CompletedSLPListPDFSuccess,
  CompletedSLPListPDFSuccessPayload,
  CompletedSLPListRequest,
  CompletedSLPListSuccess,
  CompletedSLPListSuccessPayload,
  PLAUserListFailure,
  PLAUserListFailurePayload,
  PLAUserListPayload,
  PLAUserListRequest,
  PLAUserListSuccess,
  PLAUserListSuccessPayload,
  SLPRequestsFailure,
  SLPRequestsFailurePayload,
  SLPRequestsPayload,
  SLPRequestsPDFFailure,
  SLPRequestsPDFFailurePayload,
  SLPRequestsPDFPayload,
  SLPRequestsPDFRequest,
  SLPRequestsPDFSuccess,
  SLPRequestsPDFSuccessPayload,
  SLPRequestsRequest,
  SLPRequestsSuccess,
  SLPRequestsSuccessPayload,
  UpdateSLPContactNoteFailure,
  UpdateSLPContactNoteFailurePayload,
  UpdateSLPContactNotePayload,
  UpdateSLPContactNoteRequest,
  UpdateSLPContactNoteSuccess,
  UpdateSLPContactNoteSuccessPayload,
  UpdateSLPContactProgressFailure,
  UpdateSLPContactProgressFailurePayload,
  UpdateSLPContactProgressPayload,
  UpdateSLPContactProgressRequest,
  UpdateSLPContactProgressSuccess,
  UpdateSLPContactProgressSuccessPayload,
  UpdateSLPParticipationFailure,
  UpdateSLPParticipationFailurePayload,
  UpdateSLPParticipationPayload,
  UpdateSLPParticipationRequest,
  UpdateSLPParticipationSuccess,
  UpdateSLPParticipationSuccessPayload,
  ViewSLPGoalsAssessmentPDFFailure,
  ViewSLPGoalsAssessmentPDFFailurePayload,
  ViewSLPGoalsAssessmentPDFPayload,
  ViewSLPGoalsAssessmentPDFRequest,
  ViewSLPGoalsAssessmentPDFSuccess,
  ViewSLPGoalsAssessmentPDFSuccessPayload,
} from "./type";

export const slpRequestsRequest = (
  payload: SLPRequestsPayload
): SLPRequestsRequest => ({
  type: SLP_REQUESTS_REQUEST,
  payload,
});

export const slpRequestsSuccess = (
  payload: SLPRequestsSuccessPayload
): SLPRequestsSuccess => ({
  type: SLP_REQUESTS_SUCCESS,
  payload,
});

export const slpRequestsFailure = (
  payload: SLPRequestsFailurePayload
): SLPRequestsFailure => ({
  type: SLP_REQUESTS_FAILURE,
  payload,
});

export const plaUserListRequest = (
  payload: PLAUserListPayload
): PLAUserListRequest => ({
  type: PLA_USER_LIST_REQUEST,
  payload,
});

export const plaUserListSuccess = (
  payload: PLAUserListSuccessPayload
): PLAUserListSuccess => ({
  type: PLA_USER_LIST_SUCCESS,
  payload,
});

export const plaUserListFailure = (
  payload: PLAUserListFailurePayload
): PLAUserListFailure => ({
  type: PLA_USER_LIST_FAILURE,
  payload,
});

export const slpRequestsPDFRequest = (
  payload: SLPRequestsPDFPayload
): SLPRequestsPDFRequest => ({
  type: SLP_REQUESTS_PDF_REQUEST,
  payload,
});

export const slpRequestsPDFSuccess = (
  payload: SLPRequestsPDFSuccessPayload
): SLPRequestsPDFSuccess => ({
  type: SLP_REQUESTS_PDF_SUCCESS,
  payload,
});

export const slpRequestsPDFFailure = (
  payload: SLPRequestsPDFFailurePayload
): SLPRequestsPDFFailure => ({
  type: SLP_REQUESTS_PDF_FAILURE,
  payload,
});

export const updateSLPContactProgressRequest = (
  payload: UpdateSLPContactProgressPayload
): UpdateSLPContactProgressRequest => ({
  type: UPDATE_SLP_CONTACT_PROGRESS_REQUEST,
  payload,
});

export const updateSLPContactProgressSuccess = (
  payload: UpdateSLPContactProgressSuccessPayload
): UpdateSLPContactProgressSuccess => ({
  type: UPDATE_SLP_CONTACT_PROGRESS_SUCCESS,
  payload,
});

export const updateSLPContactProgressFailure = (
  payload: UpdateSLPContactProgressFailurePayload
): UpdateSLPContactProgressFailure => ({
  type: UPDATE_SLP_CONTACT_PROGRESS_FAILURE,
  payload,
});

export const completedSLPListRequest = (
  payload: CompletedSLPListPayload
): CompletedSLPListRequest => ({
  type: COMPLETED_SLP_LIST_REQUEST,
  payload,
});

export const completedSLPListSuccess = (
  payload: CompletedSLPListSuccessPayload
): CompletedSLPListSuccess => ({
  type: COMPLETED_SLP_LIST_SUCCESS,
  payload,
});

export const completedSLPListFailure = (
  payload: CompletedSLPListFailurePayload
): CompletedSLPListFailure => ({
  type: COMPLETED_SLP_LIST_FAILURE,
  payload,
});

export const completedSLPListPDFRequest = (
  payload: CompletedSLPListPDFPayload
): CompletedSLPListPDFRequest => ({
  type: COMPLETED_SLP_LIST_PDF_REQUEST,
  payload,
});

export const completedSLPListPDFSuccess = (
  payload: CompletedSLPListPDFSuccessPayload
): CompletedSLPListPDFSuccess => ({
  type: COMPLETED_SLP_LIST_PDF_SUCCESS,
  payload,
});

export const completedSLPListPDFFailure = (
  payload: CompletedSLPListPDFFailurePayload
): CompletedSLPListPDFFailure => ({
  type: COMPLETED_SLP_LIST_PDF_FAILURE,
  payload,
});

export const updateSLPParticipationRequest = (
  payload: UpdateSLPParticipationPayload
): UpdateSLPParticipationRequest => ({
  type: UPDATE_SLP_PARTICIPATION_REQUEST,
  payload,
});

export const updateSLPParticipationSuccess = (
  payload: UpdateSLPParticipationSuccessPayload
): UpdateSLPParticipationSuccess => ({
  type: UPDATE_SLP_PARTICIPATION_SUCCESS,
  payload,
});

export const updateSLPParticipationFailure = (
  payload: UpdateSLPParticipationFailurePayload
): UpdateSLPParticipationFailure => ({
  type: UPDATE_SLP_PARTICIPATION_FAILURE,
  payload,
});

export const updateSLPContactNoteRequest = (
  payload: UpdateSLPContactNotePayload
): UpdateSLPContactNoteRequest => ({
  type: UPDATE_SLP_CONTACT_NOTE_REQUEST,
  payload,
});

export const updateSLPContactNoteSuccess = (
  payload: UpdateSLPContactNoteSuccessPayload
): UpdateSLPContactNoteSuccess => ({
  type: UPDATE_SLP_CONTACT_NOTE_SUCCESS,
  payload,
});

export const updateSLPContactNoteFailure = (
  payload: UpdateSLPContactNoteFailurePayload
): UpdateSLPContactNoteFailure => ({
  type: UPDATE_SLP_CONTACT_NOTE_FAILURE,
  payload,
});

export const viewSLPGoalsAssessmentPDFRequest = (
  payload: ViewSLPGoalsAssessmentPDFPayload
): ViewSLPGoalsAssessmentPDFRequest => ({
  type: VIEW_SLP_GOALS_ASSESSMENT_PDF_REQUEST,
  payload,
});

export const viewSLPGoalsAssessmentPDFSuccess = (
  payload: ViewSLPGoalsAssessmentPDFSuccessPayload
): ViewSLPGoalsAssessmentPDFSuccess => ({
  type: VIEW_SLP_GOALS_ASSESSMENT_PDF_SUCCESS,
  payload,
});

export const viewSLPGoalsAssessmentPDFFailure = (
  payload: ViewSLPGoalsAssessmentPDFFailurePayload
): ViewSLPGoalsAssessmentPDFFailure => ({
  type: VIEW_SLP_GOALS_ASSESSMENT_PDF_FAILURE,
  payload,
});
